import { Helmet } from "react-helmet-async";
import { BRAND } from "@/data/mockData";

const SITE = "https://sirija.online";

export default function Seo({
  title,
  description,
  path = "/",
  image = `${SITE}/sirija-logo.jpg`,
  noindex = false,
  jsonLd,
}) {
  const fullTitle = title ? `${title} — SIRIJA` : `SIRIJA — ${BRAND.tagline}`;
  const desc =
    description ||
    "SIRIJA — premium silver jewellery showroom in Raviwar Peth, Pune. 925 sterling & 999 fine silver, hallmarked, hand-finished. Bridal, festive, daily, pooja & corporate gifting.";
  const url = `${SITE}${path}`;

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta name="robots" content={noindex ? "noindex,nofollow" : "index,follow,max-image-preview:large"} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="SIRIJA" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="en_IN" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />

      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
}
